module.exports = "/_next/static/images/IdentityResolutionGuide-f2dca3536375e1bcf6513f942ed47225.png";